import React from 'react';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import { graphql, useStaticQuery } from 'gatsby';

const Screenshots = ({ project }) => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        screenshots {
          img {
            publicURL
          }
          img_name
          id
        }
        screenshot_heading
      }
    }
  `);

  const {
    strapiHomePage: { screenshots_heading, screenshots },
  } = data;

  const params = {
    slidesPerView: 5,
    loop: true,
    speed: 1000,
    spaceBetween: 30,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    // Responsive breakpoints
    breakpoints: {
      1499: {
        slidesPerView: 5,
      },

      991: {
        slidesPerView: 3,
      },

      767: {
        slidesPerView: 3,
      },

      575: {
        slidesPerView: 2,
      },
    },
  };

  return (
    <section className='app-shot-one' id='screenshots'>
      <div className='container-fluid'>
        <div className='block-title text-center'>
          <h2 className='block-title__title'>{screenshots_heading}</h2>
        </div>
        <Swiper {...params}>
          {screenshots.map((screenshot) => {
            return (
              <div className='item' key={screenshot.id}>
                {project &&
                  screenshot.img_name.split('_')[0] ===
                    project.toLowerCase() && (
                    <img
                      src={screenshot.img.publicURL}
                      alt={screenshot.img_name}
                    />
                  )}
              </div>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};
export default Screenshots;
